export enum ValidEnum {
    NOT_SET,
    VALID,
    INVALID
}